import { EdgeListAnnouncementsRepository } from '@/modules/connect/infra'
import type { ListAnnouncements } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeListAnnouncements(): ListAnnouncements {
  return new EdgeListAnnouncementsRepository(makeSupabaseEdgeHttpClient()).execute
}
